import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a05e12af6558f001438455c_1779780898567/detailreveal_1778770217103/src/app/home/page.tsx");
